import React, { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router";
import Menu, { MenuBaseProps } from "./Menu";
import { Container } from "./styles";
import useKeyPress from "../../utils/custom/useKeyPress";
import { useCookies } from "react-cookie";
import moment from "moment";
import dayjs from "dayjs";

export interface SideBarProps {
  menuList: MenuBaseProps[];
  children?: ReactNode;
}

export const SideBar = ({ menuList, children }: SideBarProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isSelected = (path: string) => {
    return pathname.includes(path);
  };

  const [cookies, setCookie, removeCookie] = useCookies();
  const expires = moment().add("100", "y").toDate();
  const handleKeyDown = async (event: KeyboardEvent) => {
    let element: HTMLElement = event.target as HTMLElement;
    if (element) {
      if (element.querySelector("div")?.id !== "openedDlg") {
        switch (element.tagName) {
          case "INPUT":
          case "LI":
          case "TEXTAREA":
            break;
          default: {
            if (event.key === "h") {
              removeCookie("page", { path: "/" });
              removeCookie("startDate", { path: "/" });
              removeCookie("status", { path: "/" });
              removeCookie("hPage", { path: "/" });
              removeCookie("hStartDate", { path: "/" });
              removeCookie("hRowsPerPage", { path: "/" });
              removeCookie("language", { path: "/" });
              removeCookie("category", { path: "/" });

              event.preventDefault();
              setCookie("menu", "/history", { path: "/", expires });
              navigate(`/history`);
              window.location.reload();
            } else if (event.key === "t") {
              setCookie("status", "All", { path: "/", expires });
              setCookie("startDate", dayjs().subtract(1, "week").toDate(), {
                path: "/",
                expires,
              });
              setCookie("endDate", dayjs().toDate(), { path: "/", expires });
              setCookie("tSort", "asc", { path: "/", expires });
              event.preventDefault();
              setCookie("menu", "/templates", { path: "/", expires });
              navigate(`/templates`);
              window.location.reload();
            } else if (event.key === "m") {
              setCookie("mStatus", "Published", { path: "/", expires });
              setCookie("mStartDate", dayjs().subtract(1, "month").toDate(), {
                path: "/",
                expires,
              });
              setCookie("mEndDate", dayjs().toDate(), { path: "/", expires });
              setCookie("mSort", "asc", { path: "/", expires });
              event.preventDefault();
              setCookie("menu", "/moderation", { path: "/", expires });
              navigate(`/moderation`);
              window.location.reload();
            }
          }
        }
      }
    }
  };

  useKeyPress(["h", "t", "c", "m"], handleKeyDown);

  return (
    <Container>
      {menuList.map((menu) => (
        <Menu key={menu.title} {...menu} isSelected={isSelected(menu.path)} />
      ))}
      {children}
    </Container>
  );
};

export default SideBar;
